import Enumerable from "linq";
import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { DRCXAvailableOptionalColumn } from "../../common/models/drcx/DRCXAvailableOptionalColumn";
import {  PageConfigurationModel4, PageConfigurationTypeEnum } from "../../services/page-configuration-service/Models";
import { mapToAvailableOptionalColumnLookup } from "../../services/page-configuration-service/PageConfiguartionServiceUtils";
import PageConfigurationService from "../../services/page-configuration-service/PageConfigurationService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
//import { useDRCXOptionalColumns } from "../drcx/UseDRCXOptionalColumns";
import { keys } from "./Keys";
import { usePageConfigurationItems } from "./UsePageConfigurationItems";

export type UsePageConfigurationParameters = {
    groupID: number;
    configurationID: number;
    pageConfigurationType: PageConfigurationTypeEnum
} & BaseUseQueryParameters<PageConfigurationModel4>;


export function usePageConfiguration({
    groupID,
    configurationID,
    pageConfigurationType,
    enabled,
    onError,
    onSuccess
}: UsePageConfigurationParameters) {

    const { refetch: getOptionalColumns } = usePageConfigurationItems({
        groupID,
        pageConfigurationType,
        enabled: false
    });

    return useQuery<PageConfigurationModel4 | undefined, RestError>(
        keys.configuration(groupID, configurationID, pageConfigurationType),
       async ({ signal }) => {

            if (configurationID > -1) {
                return PageConfigurationService.getAccessiblePageConfiguration4(groupID, configurationID, signal);
            } else {
                const availableItems = await getOptionalColumns();

                const optionalColumns = mapToAvailableOptionalColumnLookup(pageConfigurationType === PageConfigurationTypeEnum.SummaryListing_RTS ? 
                    eLynxObjectTypeEnum.Device : 
                    eLynxObjectTypeEnum.Well,
                    availableItems.data?.attributeColumns ?? []) as Enumerable.ILookup<string, DRCXAvailableOptionalColumn>;

                return availableItems?.data
                    ? Promise.resolve(PageConfigurationModel4.createDefaultPageConfiguration(-1, pageConfigurationType, optionalColumns))
                    : Promise.resolve(undefined);

            }
        },
        {
            enabled,
            onError,
            onSuccess,
            staleTime: Infinity,
            refetchInterval: Infinity
        }        
    );
}
